/**
 * Lightweight fuzzy matcher.
 * Returns a score in [0, 1] — higher = better match.
 * Boosts substring hits and rewards tokens found in any order.
 */
export function fuzzyScore(query, text) {
  if (!query) return 1;
  if (!text) return 0;
  const q = query.toLowerCase().trim();
  const t = text.toLowerCase();

  // Direct substring — always a strong hit.
  if (t.includes(q)) return 1;

  // Token-based: every query token must be found (any order).
  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return 0;
  let hits = 0;
  for (const tok of tokens) {
    if (tok.length < 2) continue;
    if (t.includes(tok)) {
      hits += 1;
    }
  }
  const tokenScore = hits / tokens.length;
  if (tokenScore > 0) return 0.4 + tokenScore * 0.5;

  // Character-order fuzzy — checks whether q's characters appear in order in t.
  let ti = 0;
  let matched = 0;
  for (let qi = 0; qi < q.length; qi += 1) {
    const ch = q[qi];
    if (ch === ' ') continue;
    while (ti < t.length && t[ti] !== ch) ti += 1;
    if (ti >= t.length) return 0;
    matched += 1;
    ti += 1;
  }
  const density = matched / q.replace(/\s/g, '').length;
  return density * 0.35;
}

/**
 * Fuzzy-match a query against multiple weighted fields on an item.
 * fields: [{ get: (item) => string, weight: number }]
 */
export function fuzzyMatch(item, query, fields) {
  let best = 0;
  for (const f of fields) {
    const s = fuzzyScore(query, f.get(item)) * (f.weight ?? 1);
    if (s > best) best = s;
  }
  return best;
}
